import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import { Apps } from '../../../../../models'
// import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import 'alertifyjs/build/css/alertify.css';
import { toast } from "react-toastify";
import { ValidateAdminRole } from '../../../../../helper/validateRole';
import { Auth } from 'aws-amplify';
import Layout from '../../../../../components/common/nav/admin/nav.component';
import AWS from "aws-sdk"
import Login from '../../../../../setup/auth/login.component';
import awsmobile from "../../../../../aws-exports";
import { GetValueFromArray, graphQLGetAllData } from '../../../../../helper/commonfunctions';
import { FilterMatchMode } from 'primereact/api';

export default function ReportList() {

    //filter data
    const dtApp = useRef(null);

    //Validate admin Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [allSchools, setAllSchools] = useState("");
    const [state, setState] = useState(false);
    const [allFormData, setAllFormData] = useState([]);
    const [allWeeklyAbsenceReport, setAllWeeklyAbsenceReport] = useState([]);
    const [allCertificatedAdminWeeklyAbsenceReport, setAllCertificatedAdminWeeklyAbsenceReport] = useState([]);
    const [allClassifiedSubRequestReport, setAllClassifiedSubRequestReport] = useState([]);
    const [allCertificatedSubInitiateRequestReport, setAllCertificatedSubInitiateRequestReport] = useState([]);
    const [allTimeReport, setAllTimeReport] = useState([]);
    const [allSixthPeriodAssignmentInitiateReport, setAllSixthPeriodAssignmentInitiateReport] = useState([]);
    const [allStipendMastersReport, setAllStipendMastersReport] = useState([]);
    const [allPersonnelActionFormReport, setAllPersonnelActionFormReport] = useState([]);
    const [allPSA, setAllPSAReport] = useState([]);

    const [reportLoading, setReportLoading] = useState(true);
    const appIdData = Apps;
    const [filters, setFilters] = useState({
        formName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        schoolName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
        totalFormCountInitiated: { value: null, matchMode: FilterMatchMode.CONTAINS },
        totalFormCountCompleted: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    const exportFilteredDataToCSV = async (fileName) => {
        dtApp.current.exportCSV('');
    }

    const CounterAction = (row, index) => {
        return (
            (index.rowIndex) + 1
        );
    };


    let navigateTo = useNavigate();


    //Get All List -Asharani Navale- Sept/29/2023
    async function BindList() {

        try {

            //weekly Absence Report
            var weeklyAbsenceReport = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReports");
            setAllWeeklyAbsenceReport(weeklyAbsenceReport);

            //Certificated Admin weekly Absence Report
            var CertificatedAdminWeeklyAbsenceReport = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReports");
            setAllCertificatedAdminWeeklyAbsenceReport(CertificatedAdminWeeklyAbsenceReport);

            //Classified SubRequest Report
            var ClassifiedSubstituteRequestsReport = await graphQLGetAllData("listSubstituteCertificateRequests");
            setAllClassifiedSubRequestReport(ClassifiedSubstituteRequestsReport);

            //Certificated SubInitiateRequest Report
            var CertificatedSubInitiateRequestsReport = await graphQLGetAllData("listCertificatedSubInitiateRequests");
            setAllCertificatedSubInitiateRequestReport(CertificatedSubInitiateRequestsReport);

            //Time Report
            var TimeReportInitiateReports = await graphQLGetAllData("listTimeReportInitiateReports");
            setAllTimeReport(TimeReportInitiateReports);

            //SIX_PERIOD Report
            // var SixthPeriodAssignmentInitiateReports = await graphQLGetAllData("listSixthPeriodAssignmentInitiateReports");
            // setAllSixthPeriodAssignmentInitiateReport(SixthPeriodAssignmentInitiateReports);

            //STIPENDS_FORM Report
            var StipendMasters = await graphQLGetAllData("listStipendMasters");
            setAllStipendMastersReport(StipendMasters);

            //Personnel Action Initiator Forms Report
            // var PersonnelActionInitiatorForms = await graphQLGetAllData("listPersonnelActionInitiatorForms");
            // setAllPersonnelActionFormReport(PersonnelActionInitiatorForms);

            //PSA Report
            var PSAConsultants = await graphQLGetAllData("listPSAConsultants");
            setAllPSAReport(PSAConsultants);

            var getAllSchools = await graphQLGetAllData("listSchools")
            setAllSchools(getAllSchools)
            setState(true);
        }
        catch (error) {
            console.log(error);
        }

    }

    async function GetUserData(userId) {
        const cognito = await new AWS.CognitoIdentityServiceProvider();
        let submittedUser = "";
        let submittedBy = "-";

        if (userId) {
            try {
                submittedUser = await cognito.adminGetUser({
                    UserPoolId: awsmobile.aws_user_pools_id,
                    Username: userId,
                }).promise();

                let exist = submittedUser ? submittedUser : '';
                let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                let name = GetValueFromArray(exist.UserAttributes, "name");

                submittedBy = lastName + ", " + firstName ? lastName?lastName:'' + ", " + firstName:name;
            } catch (e) {
                //console.log(e)
            }
        } else {
            submittedBy = "-"
        }
        return submittedBy;
    }

    async function GetAllAppData() {

        try {

            //Asharani Navale- Sept/29/2023
            let completeData = [];

            //weekly Absence Report
            const uniqueSchools = Array.from(new Set(allWeeklyAbsenceReport.map(item => item.school_id)));

            for (let i = 0; i < uniqueSchools.length; i++) {

                var schoolResponses = allWeeklyAbsenceReport.filter(e => e.school_id.includes(uniqueSchools[i]))

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.user_id)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.school_id.includes(uniqueSchools[i]) && e.user_id.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueSchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)

                    var statusResponses = userResponses.filter(e => e.payroll_status && e.payroll_status.includes('PAYROLL_ACCEPTED'))

                    completeData.push({ "formName": appIdData.WEEKLY_ABSENCE_REPORT, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": statusResponses.length })
                }
            }

            //Certificated Admin weekly Absence Report
            const uniqueallCertificatedAdminWeeklyAbsenceReportSchools = Array.from(new Set(allCertificatedAdminWeeklyAbsenceReport.map(item => item.school_id)));

            for (let i = 0; i < uniqueallCertificatedAdminWeeklyAbsenceReportSchools.length; i++) {

                var schoolResponses = allCertificatedAdminWeeklyAbsenceReport.filter(e => e.school_id.includes(uniqueallCertificatedAdminWeeklyAbsenceReportSchools[i]))

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.user_id)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.school_id.includes(uniqueallCertificatedAdminWeeklyAbsenceReportSchools[i]) && e.user_id.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueallCertificatedAdminWeeklyAbsenceReportSchools[i])
                    let userId = uniqueUsers[j];

                   let submittedBy = await GetUserData(userId)

                    var statusResponses = userResponses.filter(e => e.payroll_status && e.payroll_status.includes('PAYROLL_ACCEPTED'))

                    completeData.push({ "formName": appIdData.WEEKLY_ABSENCE_REPORT_ADMIN, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": statusResponses.length })
                }
            }

            //Classified SubRequest Report
            const uniqueAllClassifiedSubRequestReportSchools = Array.from(new Set(allClassifiedSubRequestReport.map(item => item.locationId)));

            for (let i = 0; i < uniqueAllClassifiedSubRequestReportSchools.length; i++) {

                var schoolResponses = allClassifiedSubRequestReport.filter(e => e.locationId.includes(uniqueAllClassifiedSubRequestReportSchools[i]))
                // console.log('schoolResponses', schoolResponses)

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.createdBy)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.locationId.includes(uniqueAllClassifiedSubRequestReportSchools[i]) && e.createdBy.includes(uniqueUsers[j]))
                    let schoolName = allSchools.find(o => o.id === uniqueAllClassifiedSubRequestReportSchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)
                    let counter=0;

                    for (let k = 0; k < userResponses.length; k++) {

                        const SubstituteCertificateRequestTransactionCycle = await graphQLGetAllData("listSubstituteCertificateRequestTransactionCycles", [{ reportId: { eq: userResponses[k].id } }])
                        // SubstituteCertificateRequestTransactionCycle = SubstituteCertificateRequestTransactionCycle.sort((b, a) => a.status.localeCompare(b.status));
                        var statusResponses = SubstituteCertificateRequestTransactionCycle.filter(e => e.status && e.status.includes('Acknowledge'))
                        if(statusResponses){
                            counter+=statusResponses.length;
                        }
                    }

                    completeData.push({ "formName": appIdData.CLASSIFIED_SUB_REQUEST, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": counter })
                }
            }

            //Certificated Sub InitiateRequest Report

            const uniqueAllCertificatedSubInitiateRequestReportSchools = Array.from(new Set(allCertificatedSubInitiateRequestReport.map(item => item.schoolOrDeptId)));

            for (let i = 0; i < uniqueAllCertificatedSubInitiateRequestReportSchools.length; i++) {

                var schoolResponses = allCertificatedSubInitiateRequestReport.filter(e => e.schoolOrDeptId.includes(uniqueAllCertificatedSubInitiateRequestReportSchools[i]))

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.submittedBy)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.schoolOrDeptId.includes(uniqueAllCertificatedSubInitiateRequestReportSchools[i]) && e.submittedBy.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueAllCertificatedSubInitiateRequestReportSchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)
                    let counter=0;
                    for (let k = 0; k < userResponses.length; k++) {

                        const CertificatedSubRequestTransactionCycles = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: userResponses[k].id } }])

                        // CertificatedSubRequestTransactionCycles = CertificatedSubRequestTransactionCycles.sort((b, a) => a.status.localeCompare(b.status));

                        var statusResponses = CertificatedSubRequestTransactionCycles.filter(e => e.status && e.status.includes('CLOSED'))
                        if(statusResponses){
                            counter+=statusResponses.length;
                        }
                    }

                    completeData.push({ "formName": appIdData.SUBSTITUTE_REQUEST_CERTIFICATED, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": counter })
                }
            }


            //Time Report
            // console.log(allTimeReport, 'allTimeReport')
            const uniqueAllTimeReportSchools = Array.from(new Set(allTimeReport.map(item => item.school_Department_Id)));

            for (let i = 0; i < uniqueAllTimeReportSchools.length; i++) {

                var schoolResponses = allTimeReport.filter(e => e.school_Department_Id.includes(uniqueAllTimeReportSchools[i]))
                // console.log('schoolResponses', schoolResponses)

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.Created_By)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.school_Department_Id.includes(uniqueAllTimeReportSchools[i]) && e.Created_By.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueAllTimeReportSchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)

                    console.log('userResponses->', userResponses)
                    let counter=0;
                    for (let k = 0; k < userResponses.length; k++) {

                        console.log('userResponsesNew->id', userResponses[k].id)

                        const TimeReportTransactionCycles = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: userResponses[k].id } }])

                        // TimeReportTransactionCycles = TimeReportTransactionCycles.sort((b, a) => a.status.localeCompare(b.status));

                        console.log('TimeReportTransactionCycles', TimeReportTransactionCycles[0])

                        var statusResponses = TimeReportTransactionCycles.filter(e => e.status && e.status.includes('Closed'))

                        if(statusResponses){
                            counter+=statusResponses.length;
                        }
                        console.log('statusResponses', statusResponses)
                    }

                    completeData.push({ "formName": appIdData.TIME_REPORT, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": counter})
                }
            }

            //SIX Period Report
            /* console.log(allSixthPeriodAssignmentInitiateReport, 'allSixthPeriodAssignmentInitiateReport')
            let data=[];
            for (let i = 0; i < allSixthPeriodAssignmentInitiateReport.length; i++) 
            {
                let schoolName = allSchools.find(o => o.name === allSixthPeriodAssignmentInitiateReport[i].assighment_at)

                data.push({ "assighment_at": schoolName?.id, "created_by": allSixthPeriodAssignmentInitiateReport[i].created_by })
            }

            const uniqueAllSixthPeriodAssignmentInitiateReportSchools = Array.from(new Set(data.map(item => item.assighment_at)));

            for (let i = 0; i < uniqueAllSixthPeriodAssignmentInitiateReportSchools.length; i++) {

                var schoolResponses = data.filter(e => e.assighment_at.includes(uniqueAllSixthPeriodAssignmentInitiateReportSchools[i]))

                // console.log('schoolResponses', schoolResponses)

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.created_by)));

                for (let j = 0; j < uniqueUsers.length; j++) {

                    var userResponses = schoolResponses.filter(e => e.assighment_at.includes(uniqueAllSixthPeriodAssignmentInitiateReportSchools[i]) && e.Created_By.includes(uniqueUsers[j]))

                    let submittedBy = "-";
                    let submittedUser = "";
                    let schoolName = allSchools.find(o => o.name === uniqueAllSixthPeriodAssignmentInitiateReportSchools[i])
                    let userId = uniqueUsers[j];

                    if (userId) {
                        try {
                            submittedUser = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: userId,
                            }).promise();

                            let exist = submittedUser ? submittedUser : '';
                            let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                            let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                            submittedBy = firstName + " " + lastName
                        } catch (e) {
                            //console.log(e)
                        }
                    } else {
                        submittedBy = "-"
                    }
                    console.log('userResponses->', userResponses)

                    for (let k = 0; k < userResponses.length; k++) {

                        console.log('userResponsesNew->id', userResponses[k].id)

                        const SixthPeriodReportTransactionCycles = await graphQLGetAllData("listSixthPeriodReportTransactionCycles", [{ report_Id: { eq: userResponses[k].id } }])

                        // SixthPeriodReportTransactionCycles = SixthPeriodReportTransactionCycles.sort((b, a) => a.status.localeCompare(b.status));

                        console.log('SixthPeriodReportTransactionCycles', SixthPeriodReportTransactionCycles[0])

                        var statusResponses = SixthPeriodReportTransactionCycles.filter(e => e.status && e.status.includes('Closed'))

                        console.log('statusResponses', statusResponses)
                    }

                    completeData.push({ "formName": appIdData.SIX_PERIOD, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": statusResponses.length })
                }
            } */

            //Stipend Report
            const uniqueAllStipendMastersReportSchools = Array.from(new Set(allStipendMastersReport.map(item => item.schoolId)));

            for (let i = 0; i < uniqueAllStipendMastersReportSchools.length; i++) {

                var schoolResponses = allStipendMastersReport.filter(e => e.schoolId.includes(uniqueAllStipendMastersReportSchools[i]))

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.createdBy)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.schoolId.includes(uniqueAllStipendMastersReportSchools[i]) && e.createdBy.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueAllClassifiedSubRequestReportSchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)

                    let counter = 0;
                    for (let k = 0; k < userResponses.length; k++) {
                        const StipendTransactionCycles = await graphQLGetAllData("listStipendTransactionCycles", [{ report_Id: { eq: userResponses[k].id } }])
                        // StipendTransactionCycles = StipendTransactionCycles.sort((b, a) => a.status.localeCompare(b.status));
                        var statusResponses = StipendTransactionCycles.filter(e => e.status && e.status.includes('Completed-(step 9)'))
                        if(statusResponses){
                            counter+=statusResponses.length;
                        }
                    }

                    completeData.push({ "formName": appIdData.STIPENDS_FORM, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": counter })
                }
            }

            /* //Personnel Action Form Report
            const uniqueAllPersonnelActionFormReportSchools = Array.from(new Set(allPersonnelActionFormReport.map(item => item.location)));

            for (let i = 0; i < uniqueAllPersonnelActionFormReportSchools.length; i++) {

                var schoolResponses = allPersonnelActionFormReport.filter(e => e.location.includes(uniqueAllPersonnelActionFormReportSchools[i]))
                // console.log('schoolResponses', schoolResponses)

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.created_by)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.location.includes(uniqueAllPersonnelActionFormReportSchools[i]) && e.created_by.includes(uniqueUsers[j]))

                    let submittedBy = "-";
                    let submittedUser = "";
                    let schoolName = allSchools.find(o => o.id === uniqueAllPersonnelActionFormReportSchools[i])
                    let userId = uniqueUsers[j];

                    if (userId) {
                        try {
                            submittedUser = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: userId,
                            }).promise();

                            let exist = submittedUser ? submittedUser : '';
                            let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                            let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                            submittedBy = firstName + " " + lastName
                        } catch (e) {
                            //console.log(e)
                        }
                    } else {
                        submittedBy = "-"
                    }

                    for (let k = 0; k < userResponses.length; k++) {
                        const TransactionCyclePersonnels = await graphQLGetAllData("listTransactionCyclePersonnels", [{ report_Id: { eq: userResponses[k].id } }])
                        // TransactionCyclePersonnels = TransactionCyclePersonnels.sort((b, a) => a.status.localeCompare(b.status));
                        var statusResponses = TransactionCyclePersonnels.filter(e => e.status && e.status.includes('Acknowledge'))
                        
                    }

                    completeData.push({ "formName": appIdData.PERSONNEL_ACTION_FORM, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": statusResponses.length })
                }
            } */

            //PSA Report
            const uniqueAllPSASchools = Array.from(new Set(allPSA.map(item => item.department)));

            for (let i = 0; i < uniqueAllPSASchools.length; i++) {

                var schoolResponses = allPSA.filter(e => e.department && e.department.includes(uniqueAllPSASchools[i]))
                // console.log('schoolResponses', schoolResponses)

                const uniqueUsers = Array.from(new Set(schoolResponses.map(item => item.createdBy)));

                for (let j = 0; j < uniqueUsers.length; j++) {
                    var userResponses = schoolResponses.filter(e => e.department && e.department.includes(uniqueAllPSASchools[i]) && e.createdBy.includes(uniqueUsers[j]))

                    let schoolName = allSchools.find(o => o.id === uniqueAllPSASchools[i])
                    let userId = uniqueUsers[j];

                    let submittedBy = await GetUserData(userId)
                    let counter=0;
                    for (let k = 0; k < userResponses.length; k++) {
                        const PSATransactionCycles = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: userResponses[k].id } }])
                        // PSATransactionCycles = PSATransactionCycles.sort((b, a) => a.status.localeCompare(b.status));
                        var statusResponses = PSATransactionCycles.filter(e => e.status && e.status.includes('Acknowledged'))
                        if(statusResponses){
                            counter+=statusResponses.length;
                        }
                    }

                    completeData.push({ "formName": appIdData.PERSONAL_SERVICE_AGREEMENT, "schoolName": schoolName.name, "submittedBy": submittedBy, "totalFormCountInitiated": userResponses.length, "totalFormCountCompleted": counter})
                }
            }


            setReportLoading(false)

            console.log('completeData', completeData)
            setAllFormData(completeData);

        }
        catch (error) {
            console.log(error);
        }
    }


   async function onLoad() {
    try {
       await Auth.currentSession();
       if (!ValidateAdminRole()) { userHasAuthenticated(false); }
    } catch (e) {
       console.log("error-->", e)
       userHasAuthenticated(false);
    }
 }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    useEffect(() => {
        if (state === true) {
            GetAllAppData();
        }
    }, [state]);

    return isAuthenticated ? (
        <div>
            <Layout pageTitle="Dashboard">

                <div className="">
                    <div className="dashboard-main-wrapper pr-4 mt-3">
                        <div className='wrapper-custom-views mt-8'>

                            <div className="flex flex-1 flex-wrap pt-5 px-0 top-action-wrapper mt-4">
                                <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                    <div className="md:flex block mb-4">
                                        <h2 className="page-title ">Form Report</h2>
                                    </div>
                                </div>
                                <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side mb-4">
                                    <Link
                                        to="#"
                                        onClick={(e) => {
                                            exportFilteredDataToCSV("FormReport.csv");
                                            e.preventDefault()
                                        }}
                                        className=" "
                                    >
                                        {" "}
                                        <i className="pi pi-download "></i>
                                    </Link>

                                    <div className="md:flex block gap-3">
                                        <Link to="/masters" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231]  dark:text-[#FFFFFF]">Back</Link>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className={allFormData.length === 0 ? "datatableemptymessage arrowhide" : "payroll  arrowshow"}>
                                    <DataTable ref={dtApp} className="custpaginator custIcons custmBtnTable custTable border-1" filters={filters} filterDisplay="row" sortOrder="1" sortField="schoolName" scrollable value={allFormData} paginator rows={10} rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" loading={reportLoading}>

                                        <Column header="SL#" body={CounterAction} style={{ minWidth: '3rem' }}></Column>
                                        <Column field="formName" header="Form Name" filter filterPlaceholder="Search" sortable style={{ minWidth: '8rem' }}></Column>
                                        <Column field="schoolName" header="School / Department Name" filter filterPlaceholder="Search" sortable style={{ minWidth: '8rem' }}></Column>
                                        <Column field="submittedBy" header="Submitted By" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="totalFormCountInitiated" header="Total Count of Initiated Forms" style={{ minWidth: '2rem' }}></Column>
                                        <Column field="totalFormCountCompleted" header="Total Count of Forms Completed(Acknowledged)" style={{ minWidth: '2rem' }}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    ) : (
        <Login sessionExpired={1} />
    )
}